/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationMembershipsIndex } from '../../axios/organisationMembershipsIndex'
import type {
	OrganisationMembershipsIndexError,
	OrganisationMembershipsIndexPathParams,
	OrganisationMembershipsIndexQueryParams,
	OrganisationMembershipsIndexResponse,
} from '../../types/OrganisationMembershipsIndex'

export const organisationMembershipsIndexQueryKey = (
	organisation: OrganisationMembershipsIndexPathParams['organisation'],
	params?: OrganisationMembershipsIndexQueryParams,
) => [
	{ url: '/organisations/:organisation/memberships', params: { organisation } },
	...(params ? [params] : []),
] as const

export type OrganisationMembershipsIndexQueryKey = ReturnType<typeof organisationMembershipsIndexQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationMembershipsController.php OrganisationMembershipsController::index */
export function organisationMembershipsIndexQueryOptions(
	organisation: OrganisationMembershipsIndexPathParams['organisation'],
	params?: OrganisationMembershipsIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationMembershipsIndexResponse,
		AxiosError<OrganisationMembershipsIndexError>,
		OrganisationMembershipsIndexResponse,
		OrganisationMembershipsIndexQueryKey
	>({
		queryKey: organisationMembershipsIndexQueryKey(organisation, params),
		queryFn: ({ signal }) =>
			organisationMembershipsIndex(organisation, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationMembershipsController.php OrganisationMembershipsController::index */
export function useOrganisationMembershipsIndex<TSelectData = OrganisationMembershipsIndexResponse>(
	organisation: OrganisationMembershipsIndexPathParams['organisation'],
	params?: OrganisationMembershipsIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationMembershipsIndexResponse,
					AxiosError<OrganisationMembershipsIndexError>,
					TSelectData,
					OrganisationMembershipsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationMembershipsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationMembershipsIndexQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationMembershipsController.php OrganisationMembershipsController::index */
export function useOrganisationMembershipsIndexSuspense<TSelectData = OrganisationMembershipsIndexResponse>(
	organisation: OrganisationMembershipsIndexPathParams['organisation'],
	params?: OrganisationMembershipsIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationMembershipsIndexResponse,
					AxiosError<OrganisationMembershipsIndexError>,
					TSelectData,
					OrganisationMembershipsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationMembershipsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationMembershipsIndexQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
